<template>
    <div>
        <!--Map Section Start-->
        <section class="p-0">
            <div class="container-fluid">
                <div class="bottom-section">
                    <div class="row">
                        <div class="col-md-6 p-0">
                            <div class="address-bar">
                                <div>
                                    <h2>United Kingdom</h2>
                                    <ul class="footer-style">
                                        <li>
                                            <div class="footer-icon">
                                                <img
                                                    :src="require('@/assets/images/locate.png')"
                                                    alt="locate"
                                                />
                                            </div>
                                            <div class="footer-address">
                                                <a href="#" class="map-address"
                                                ><span class="footer-address-text"
                                                >11 Burghfield Walk, Basingstoke, RG22 5AT</span
                                                ></a
                                                >
                                            </div>
                                        </li>
                                        <li>
                                            <div class="footer-icon">
                                                <img
                                                    :src="require('@/assets/images/telephone.png')"
                                                    alt="telephone"
                                                />
                                            </div>
                                            <div class="footer-address">
                                                <a href="#" class="map-address footer-address-text"
                                                ><span class="footer-address-text"
                                                >0203 874 1930</span
                                                ></a
                                                >
                                            </div>
                                        </li>
                                        <li>
                                            <div class="footer-icon">
                                                <img
                                                    :src="require('@/assets/images/fotter-email.png')"
                                                    alt="fotter-email"
                                                />
                                            </div>
                                            <div class="footer-address">
                                                <a href="#" class="map-address footer-address-text"
                                                ><span class="footer-address-text"
                                                >support@xtremecontrols.co.uk</span
                                                ></a
                                                >
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6 p-0">
                            <iframe
                                src="https://www.google.com/maps/embed?pb=!1m14!1m12!1m3!1d19970.699535721065!2d-1.1412388999999998!3d51.2681074!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!5e0!3m2!1sen!2suk!4v1610461496633!5m2!1sen!2suk"
                                width="600"
                                height="450"
                                frameborder="0"
                                style="border:0;"
                                allowfullscreen=""
                                aria-hidden="false"
                                tabindex="0"
                            ></iframe>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-6 p-0">
                            <iframe
                                src="https://www.google.com/maps/embed?pb=!1m14!1m12!1m3!1d51649.28752051095!2d-79.95641333828588!3d35.99390035604082!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!5e0!3m2!1sen!2suk!4v1610461575910!5m2!1sen!2suk"
                                width="600"
                                height="450"
                                frameborder="0"
                                style="border:0;"
                                allowfullscreen=""
                                aria-hidden="false"
                                tabindex="0"
                            ></iframe>
                        </div>
                        <div class="col-md-6 p-0">
                            <div class="address-bar">
                                <div class="ml-4">
                                    <h2 class="mt-5">USA</h2>
                                    <ul class="footer-style">
                                        <li>
                                            <div class="footer-icon">
                                                <img
                                                    :src="require('@/assets/images/locate.png')"
                                                    alt="locate"
                                                />
                                            </div>
                                            <div class="footer-address">
                                                <a href="#" class="map-address footer-address-text"
                                                ><span class="footer-address-text"
                                                >PO Box 654, Jamestown, NC 27282, United
                                                    States</span
                                                ></a
                                                >
                                            </div>
                                        </li>
                                        <li>
                                            <div class="footer-icon">
                                                <img
                                                    :src="require('@/assets/images/telephone.png')"
                                                    alt="telephone"
                                                />
                                            </div>
                                            <div class="footer-address">
                                                <a href="#" class="map-address footer-address-text"
                                                ><span class="footer-address-text"
                                                >(704) 303 8602</span
                                                ></a
                                                >
                                            </div>
                                        </li>
                                        <li>
                                            <div class="footer-icon">
                                                <img
                                                    :src="require('@/assets/images/fotter-email.png')"
                                                    alt="fotter-email"
                                                />
                                            </div>
                                            <div class="footer-address">
                                                <a href="#" class="map-address footer-address-text"
                                                ><span class="footer-address-text"
                                                >support@xtremecontrols.com</span
                                                ></a
                                                >
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    <!--Map Section Ends-->
    </div>
</template>
<script>
export default {
    name: "Map"
}
</script>
<style>
.footer-address-text {
  color: #444444 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/map.vue